<template>
   <router-view/>
</template>

<script>
import { rechargeParam } from '../assets/js/common.js'
export default {
  name: 'emptyLayout',
  data() {
    return {
      y_redirect_url: this.redirect_url + this.getUrlRelativePath()
    }
  },
  created() {
    let UA = navigator.userAgent.toLowerCase();
    
    if(/(uni-app)/.test(UA) || /(ylkids_android)/.test(UA) || /(ios1.1.0)/.test(UA)) {
      
      this.client_type="app";
      if(/(ios1.1.0)/.test(UA)){
        this.isIos=true;
      }
      // Vue.prototype.environment = true;
      
      if(/(ylkids_android)/.test(UA)) {
        let str3 = window.jsInterface.GetToken();
        localStorage.setItem("token", str3);
        //  获取用户信息
        this.getUserInfo();
        //	获取充值列表
        // this.getRechargeList();
      } else if(/(ios1.1.0)/.test(UA)) {
        //ios环境下触发有点慢
        // window.webkit.messageHandlers.tokenTnvalid.postMessage(null);
        
        window.webkit.messageHandlers.getIosToken.postMessage(null);
        setTimeout(function() {
          //  获取用户信息
          _this.getUserInfo();
          //	获取充值列表
          // _this.getRechargeList();
        }, 500)

      }
    } else {
      if(localStorage.getItem('token')) {
        //  获取用户信息
        this.getUserInfo();

      } else {
        if(this.getUrlParam("data")) {
          localStorage.setItem('auth_data', this.getUrlParam("data"));
        }

        if(localStorage.getItem('auth_data') && localStorage.getItem('version') == this.version) {
          if(localStorage.getItem("state") == this.getUrlParam("state")) {
            // 解密data
            this.$http.post("/api/v2/secret/decrypt?" + rechargeParam({}, true, true), {
              data: localStorage.getItem('auth_data')
            }, {
              emulateJSON: true
            }).then((response) => {
              if(response.data.error == 0) {

                this.decrypt_data = response.data.data.data;
                //用户登录
                if(this.isAlipayOrWechat().split(',')[0] == 'alipay') {
                  localStorage.setItem('openid', response.data.data.data.user_id);
                  localStorage.setItem('nickname', response.data.data.data.user_id);
                  localStorage.setItem('gender', response.data.data.data.gender);
                  localStorage.setItem('avatar', response.data.data.data.avatar);

                } else if(this.isAlipayOrWechat().split(',')[0] == 'wechat') {
                  localStorage.setItem('openid', response.data.data.data.unionid);
                  localStorage.setItem('nickname', response.data.data.data.nickname);
                  localStorage.setItem('gender', response.data.data.data.sex);
                  localStorage.setItem('avatar', response.data.data.data.headimgurl);
                }

                //									localStorage.setItem('openid',response.data.data.data.openid);
                //									localStorage.setItem('nickname',response.data.data.data.nickname);
                //									localStorage.setItem('gender',response.data.data.data.sex);
                //									localStorage.setItem('avatar',response.data.data.data.headimgurl);
                //									localStorage.setItem('decrypt_data',this.decrypt_data);
                //									console.log(this.decrypt_data)

                //用户登录
                this.$http.post("/api/v2/auth/login?" + rechargeParam({}, true, true), {

                  uuid: localStorage.getItem("openid"),
                  code: response.data.data.code

                }, {
                  emulateJSON: true
                }).then((response) => {
                  if(response.data.error == 0) {
                    //											console.log("用户登录"+response.data.data);
                    localStorage.setItem("token", response.data.data);
                    //											alert("用户登录")
                    //获取用户信息
                    location.href = document.location.toString().split("?")[0]
                    this.getUserInfo();
                  } else if(response.data.error == "11002") {
                    //											this.refreshToken();
                    this.$emit("getToken");
                  } else if(response.data.error == '30005') {
                    this.$router.push({
                      path: '/bind'
                    })

                  } else if(response.data.error == '11003') {
                    this.$router.push({
                      path: '/bind'
                    })
                  } else {
                    alert(response.data.msg);
                  }
                })

              } else if(response.data.error == "11002") {
                //									this.refreshToken();
                this.$emit("getToken");
              } else {
                alert(response.data.msg);

              }
            })
          } else {
            //							location.reload();
                        this.state = Math.random().toString(36).substr(2);
          localStorage.setItem('state', this.state);
          //						console.log(this.state)
          localStorage.setItem('currentRouter', this.getUrlRelativePath())
          this.$http.get("/api/v2/oauth/authorize?" + rechargeParam({
            params: {
              client_type: this.isAlipayOrWechat().split(',')[0],
              redirect_uri: this.y_redirect_url,
              scope: 'userinfo',
              state: this.state
            }
          }, false, true)).then((response) => {
            if(response.data.error == 0) {
              localStorage.setItem("version", this.version);
              window.location.href = response.data.data;
            } else if(response.data.error == "11002") {
              //								this.refreshToken();
              this.$emit("getToken");
            } else {
              alert(response.data.msg);

            }
          })
          }

        } else {
          this.state = Math.random().toString(36).substr(2);
          localStorage.setItem('state', this.state);
          //						console.log(this.state)
          localStorage.setItem('currentRouter', this.getUrlRelativePath())
          this.$http.get("/api/v2/oauth/authorize?" + rechargeParam({
            params: {
              client_type: this.isAlipayOrWechat().split(',')[0],
              redirect_uri: this.y_redirect_url,
              scope: 'userinfo',
              state: this.state
            }
          }, false, true)).then((response) => {
            if(response.data.error == 0) {
              localStorage.setItem("version", this.version);
              window.location.href = response.data.data;
            } else if(response.data.error == "11002") {
              //								this.refreshToken();
              this.$emit("getToken");
            } else {
              alert(response.data.msg);
            }
          })

        }
      }
    }
  },
  methods: {
    getUserInfo() {
      //获取用户信息
      this.$http.get("/api/v2/user/info?" + rechargeParam({
        params: {

        }
      }, false, true)).then((response) => {
        if(response.data.error == 0) {

          this.userInfo = {
            elb: response.data.data.account.elb,
            rmb: response.data.data.account.rmb
          }
          localStorage.setItem('user_id', response.data.data.account.user_id)
          localStorage.setItem('avatar', response.data.data.avatar)
          localStorage.setItem('nickname', response.data.data.nickname)
        } else if(response.data.error == "11002") {
          //							this.refreshToken();
          this.$emit("getToken");
        } else {
          alert(response.data.msg);
        }
      })
    },
    getUrlRelativePath() {
      let url = document.location.toString(),
        arrUrl = url.split("//"),
        start = arrUrl[1].indexOf("/"),
        relUrl = arrUrl[1].substring(start);//stop省略，截取从start开始到结尾的所有字符
      if (relUrl.indexOf("?") !== -1) {
        relUrl = relUrl.split("?")[0];
      }
      return relUrl;
    },
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/emptyLayout.vue